import React, { useState } from 'react'
import { Form } from 'informed'
import { useTranslation } from 'react-i18next'

import get from 'lodash/get'
import { Select, DateTimePicker } from 'components/forms/'
import { Modal } from 'components/Modal'
import Divider from 'components/Divider'
import listActiveMediaForCashRegister from '../gql/listActiveMediaForCashRegister'
import { useQuery } from 'components/graphql'
import ImageSlider from 'components/ImageSlider'
import { withRouter } from 'react-router'
import styles from '../MediaSection.module.scss'
import { listCashRegisters } from 'gql/query'
import { FormRow, FormCol } from 'style/styled'

export const routeToMediaTest = ({ history, location }) => {
	history.push('/mediacenter/testen', {
		lastPath: location.pathname
	})
}

const MediaTest = ({ data, history, unmount, location }) => {
	const now = new Date().toISOString()
	const [values, setValues] = useState({
		date: now,
		time: now
	})
	const { cashRegister, date, time } = values
	const [t] = useTranslation()

	const { data: { listActiveMediaForCashRegister: mediaArr = [] }, loading } = useQuery(listActiveMediaForCashRegister, {
		skip: !cashRegister,
		variables: {
			cashRegisterId: get(cashRegister, 'id'),
			date: date.substring(0, 10),
			time: time.substring(11)
		}
	})

	let mediaArray = mediaArr.reduce((arr, { id, name, img16_9 }) => {
		if(img16_9) {
			arr.push({
				mediaId: id,
				name,
				key: img16_9.key
			})
		}
		return arr
	}, [])

	const handleFormChange = (formValues) => {
		setValues({
			...formValues
		})
	}

	const goBack = () => {
		const lastPath = get(location, 'state.lastPath', null) || '/mediacenter'
		history.push(lastPath)
	}

	return(
		<Modal
			fullScreen
			unmount={goBack}
			className={styles.mediaTest}
			label={t('media_section.strings.test_media')}
		>
			<Form onValueChange={handleFormChange} initialValues={values} render={({ formState }) => (
				<FormRow>
					<FormCol xs>
						<Select
							field='cashRegister'
							label={t('common.fields.cash_register')}
							valueField='id'
							labelField='name'
							simpleValue={false}
							remoteOptions={{ query: listCashRegisters }}
						/>
					</FormCol>
					<FormCol xs>
						<DateTimePicker field='date' label={t('common.fields.date')} inline shrink/>
						<DateTimePicker field='time' label={t('common.fields.time')} picker='time' inline shrink/>
					</FormCol>
				</FormRow>
			)}/>
			<Divider/>
			{!!cashRegister && !loading &&
				<ImageSlider noDataText={t('media_section.strings.no_active_media')} imgArr={mediaArray}/>
			}
		</Modal>
	)
}

export default withRouter(MediaTest)
